export default function CRM() {
  return (
    <div style={{ padding: "24px" }}>
      <h2>CRM Dashboard</h2>
      <p>CRM page is under construction.</p>
    </div>
  );
}
